import { useQuery } from '@tanstack/react-query';

import { onboardingApi } from 'entities/onboarding/api/onboardingApi';
import { onboardingKeys } from 'entities/onboarding/api/queryKeys';

type Options = { enabled?: boolean };

// staleTime 0 + refetchOnMount 'always' overrides the global no-refetch defaults so state reflects
// promptly (e.g. after the wizard completes in another tab).
export function useOnboardingState({ enabled = true }: Options = {}) {
  return useQuery({
    queryKey: onboardingKeys.state(),
    queryFn: () => onboardingApi.getState(),
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
  });
}
